/* ============================================================
   La Nani — carusel de produse în formularul EasySell

   Aceleași carduri ca șina „Alege și alte seturi" de pe pagina de
   produs: poză, badge de reducere, titlu, preț, stele Judge.me,
   buton de adăugare, plus săgeata „Vezi mai multe". Datele vin din
   `[data-ln-produse]`, randat de server în main-product.liquid —
   așa avem și insignele de recenzii, care altfel n-ar exista.

   Reîmprospătarea, și de ce așa:

   Formularul EasySell e o aplicație Vue expusă în `easysellApp`.
   Componenta lor `App` are acțiunea `fetchCart`, care recitește
   coșul; fiind Vue, formularul se redesenează singur. Apoi
   `ES_UPDATE_SHIPPING_OPTION()` reaplică pragul de transport
   gratuit — fără el rămâne taxa veche pe un subtotal nou.

   Alternativele nu merg: `ES_INIT_FORM()` nu recitește coșul, iar
   simpla adăugare în coșul Shopify nu e văzută de formular.

   PLASA DE SIGURANȚĂ. Ne sprijinim pe structura internă a unei
   aplicații terțe. După fiecare adăugare verificăm dacă totalul
   chiar s-a schimbat; dacă nu, ștergem caruselul și lăsăm
   formularul exact cum era. Clientul comandă normal, nu plătește
   un produs și primește altul.
   ============================================================ */
(function () {
  'use strict';

  /* Caruselul din formular și bara de transport gratuit rămân PORNITE.
     Nu se opresc fără ca proprietarul să ceară asta explicit. */
  var CARUSEL_PORNIT = true;

  var PRAG = 350;                 /* lei, pragul de transport gratuit */
  var PRODUSE_IN_CARUSEL = 4;     /* câte produse intră în drop-down, la întâmplare */
  var MARCAJ = 'lnCaruselPus';

  var produse = null;
  var dezactivat = false;

  /* ---------- utilitare ---------- */

  function lei(bani) {
    var n = (bani / 100).toFixed(2).replace('.', ',');
    return n.replace(/,00$/, '') + ' lei';
  }

  function formular() { return document.querySelector('.es-modal-content'); }

  function componentaApp() {
    var gasit = null;
    function umbla(c) {
      if (!c || gasit) return;
      if (c.$options && c.$options.name === 'App') { gasit = c; return; }
      var copii = c.$children || [];
      for (var i = 0; i < copii.length; i++) umbla(copii[i]);
    }
    try { umbla(window.easysellApp); } catch (e) {}
    return gasit;
  }

  function reimprospateaza() {
    var app = componentaApp();
    if (!app || typeof app.fetchCart !== 'function') return Promise.reject(new Error('fara fetchCart'));
    return Promise.resolve()
      .then(function () { return app.fetchCart(); })
      .then(function () {
        if (typeof window.ES_UPDATE_SHIPPING_OPTION === 'function') {
          try { return window.ES_UPDATE_SHIPPING_OPTION(); } catch (e) {}
        }
      });
  }

  /* Coșul se citea de șase ori pe fiecare pagină de produs, fără ca omul să
     atingă nimic (măsurat: /cart.js la 915, 1578, 1808, 3636, 3693 și
     5586 ms; două se suprapuneau). Acum îl citim o dată și ținem răspunsul.
     `cos(true)` cere o citire proaspătă — numai acolo unde coșul chiar
     s-a putut schimba. */
  var cosCache = null;
  function cos(proaspat) {
    if (proaspat) cosCache = null;
    if (cosCache) return cosCache;
    cosCache = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { cosCache = null; return null; });
    return cosCache;
  }

  function citesteProduse() {
    if (produse) return produse;
    var el = document.querySelector('[data-ln-produse]');
    if (!el) return (produse = []);
    try { produse = JSON.parse(el.textContent) || []; } catch (e) { produse = []; }
    return produse;
  }

  /* ---------- bara de prag ---------- */

  /* Textul nu-i cere clientului sa socoteasca. In loc de „mai adaugi
     100,01 lei", ii spunem cate seturi ii trebuie, calculat din cel mai
     ieftin produs disponibil. Un singur lucru de inteles, nicio adunare. */
  /* Reducerea nu se scrie de mână: o luăm din produsele randate de server.
     Dacă mâine schimbi procentul, textul se schimbă singur. */
  /* Procentul NU e scris de mână — se ia din produsele din carusel, deci se
     schimbă singur când se schimbă prețurile în Shopify.

     „până la" apare doar când produsele au reduceri diferite. Altfel textul
     ar promite cea mai mare reducere din listă pentru toate, iar omul care
     deschide caruselul și vede altceva se simte tras pe sfoară. Când toate
     au aceeași reducere, scrie simplu „la −31%". */
  function reducereText(inainte, dupa) {
    var max = 0, min = Infinity;
    citesteProduse().forEach(function (p) {
      var d = Number(p.disc);
      if (!isFinite(d) || d <= 0) return;
      if (d > max) max = d;
      if (d < min) min = d;
    });
    if (!max) return '';
    var prefix = (min < max) ? ' până la <b>−' : ' la <b>−';
    return inainte + prefix + max + '%</b>' + dupa;
  }

  function actualizeazaBara(subtotal) {
    var bara = document.querySelector('[data-ln-prag]');
    if (!bara) return;
    /* Bara e și butonul care deschide caruselul, deci scriem doar în
       interiorul ei — săgeata și starea de deschis/închis rămân pe loc. */
    var gazda = bara.querySelector('.ln-prag__continut') || bara;
    var lipsa = PRAG * 100 - subtotal;

    bara.classList.toggle('ln-prag--atins', lipsa <= 0);

    /* Textul barei — vezi nota lungă de la `construieste`. Regula: omul
       trebuie să poată răspunde „nu" într-o secundă, fără să deschidă. */
    if (lipsa <= 0) {
      gazda.innerHTML = '<span aria-hidden="true">🚚</span><span><b>Transport gratuit</b>' +
        reducereText(' · mai vrei un set', '?') + '</span>';
      return;
    }

    /* pretul vine numeric din Liquid; nu mai parsam text formatat,
       tocmai ca sa nu depindem de virgula, punct sau simbolul monedei */
    var celMaiIeftin = 0;
    citesteProduse().forEach(function (p) {
      var n = Number(p.pret_num);
      if (isFinite(n) && n > 0 && (!celMaiIeftin || n < celMaiIeftin)) celMaiIeftin = n;
    });

    if (celMaiIeftin) {
      var cate = Math.ceil(lipsa / (celMaiIeftin * 100));
      gazda.innerHTML = '<span aria-hidden="true">🚚</span><span>Mai adaugi <b>' +
        (cate === 1 ? 'un set' : cate + ' seturi') + '</b>' +
        reducereText('', '') + ' și ai <b>transport gratuit</b></span>';
    } else {
      gazda.innerHTML = '<span aria-hidden="true">🚚</span><span>Transport gratuit peste ' + PRAG + ' lei</span>';
    }
  }

  /* EasySell adaugă produsul curent după ce deschide formularul, iar totalul
     se poate așeza în câțiva pași. Varianta veche recitea coșul la 0, 600,
     1500 și 3000 ms — dar cronometrul pornea la INJECTAREA caruselului,
     adică la încărcarea paginii, nu la deschiderea formularului. Prindea un
     moment care nu se întâmpla atunci: patru cereri degeaba.

     Acum bara pornește de la coșul citit deja în `incearca()`, iar mai
     departe o ține la zi observatorul de mai jos — care se declanșează
     exact când EasySell adaugă produsul, la deschiderea formularului. */

  /* Clientul poate scoate produse din formular, cu X-ul lor. Atunci
     coșul scade, iar bara trebuie sa spuna din nou cat lipseste — nu
     sa ramana pe „transport gratuit". Urmarim rezumatul comenzii si
     recitim coșul la fiecare schimbare. */
  function urmaresteCosul(f) {
    var zona = f.querySelector('.es-cart_content-group');
    if (!zona || !('MutationObserver' in window)) return;
    var asteapta = 0;
    new MutationObserver(function () {
      if (asteapta) return;
      asteapta = setTimeout(function () {
        asteapta = 0;
        if (!document.querySelector('[data-ln-prag]')) return;
        cos(true).then(function (c) { if (c) actualizeazaBara(c.total_price); });
      }, 250);
    }).observe(zona, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- adăugarea ---------- */

  /* Butonul poartă doar id-ul de variantă. Restul datelor le luăm din lista
     randată de server, ca să nu punem nume și prețuri în atribute HTML. */
  function produsDupaVarianta(idVarianta) {
    var l = citesteProduse();
    for (var i = 0; i < l.length; i++) {
      if (String(l[i].variant) === String(idVarianta)) return l[i];
    }
    return null;
  }

  function adauga(btn) {
    if (dezactivat) return;
    var id = btn.getAttribute('data-variant');
    if (!id) return;

    var textInitial = btn.textContent;
    btn.disabled = true;
    var inainte = Number(window.ES_TOTAL) || 0;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        /* Meta: AddToCart și de aici. Celelalte două căi de adăugare în coș
           (cardurile de colecție și butonul principal de pe pagina de
           produs) îl trimit de mult; asta nu-l trimitea deloc, deși tocmai
           produsele adăugate din formular sunt cele care cresc valoarea
           comenzii. Același format ca peste tot: content_type "product",
           content_ids ca text. Îl trimitem după ce adăugarea a reușit —
           atunci produsul chiar e în coș. */
        var p = produsDupaVarianta(id);
        if (p && window.lnMeta) {
          window.lnMeta.adaugaInCos({ handle: p.id, nume: p.titlu, pret: p.pret_num });
        }
        return reimprospateaza();
      })
      .then(function () { return cos(true); })
      .then(function (c) {
        if ((Number(window.ES_TOTAL) || 0) <= inainte) throw new Error('formularul nu s-a actualizat');
        if (c) actualizeazaBara(c.total_price);
        btn.textContent = 'Adăugat';
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.textContent = textInitial;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        dezactivat = true;
        ['[data-ln-carusel]', '[data-ln-prag]'].forEach(function (s) {
          var e = document.querySelector(s);
          if (e) e.remove();
        });
      });
  }

  /* ---------- cardurile, identice cu șina de pe pagina de produs ----------

     O singură diferență, intenționată: aici pozele și titlurile NU sunt
     linkuri.

     Motivul, dintr-o înregistrare Clarity: un client ajunsese la formularul
     de comandă, a atins din greșeală un produs din carusel, a fost dus pe
     pagina aceluia și comanda a rămas neterminată — s-a făcut draft.

     În formular singura acțiune trebuie să fie „Adaugă în coș". Nimic nu
     scoate omul din comandă. Pe pagina de produs, unde nu comandă nimeni în
     clipa aia, șina rămâne cu linkuri. */

  function card(p) {
    var el = document.createElement('article');
    el.className = 'rel__card';
    el.setAttribute('role', 'listitem');

    var media = '<div class="rel__media" aria-hidden="true">' +
      (p.poza ? '<img src="' + p.poza + '" alt="" width="400" height="400">' : '') +
      (p.redus ? '<span class="rel__off">&minus;' + p.disc + '%</span>' : '') + '</div>';

    el.innerHTML = media +
      '<span class="rel__name"></span>' +
      '<div class="rel__prices"><span class="rel__price">' + p.pret + '</span>' +
      (p.redus ? '<s class="rel__compare">' + p.compara + '</s>' : '') + '</div>' +
      '<div class="jdgm-widget jdgm-preview-badge ln-badge" data-id="' + p.id +
      '" data-template="index">' + (p.insigna || '') + '</div>' +
      '<button type="button" class="rel__add" data-ln-adauga data-variant="' + p.variant + '">Adaugă în coș</button>';

    /* titlul prin textContent, ca să nu injectăm HTML din date */
    el.querySelector('.rel__name').textContent = p.titlu;
    var img = el.querySelector('img');
    if (img) img.setAttribute('alt', p.titlu);
    return el;
  }

  /* ---------- construirea ---------- */

  function construieste(f, c) {
    if (f.dataset[MARCAJ]) return;

    var lista = citesteProduse();
    if (!lista.length) return;

    var inCos = {};
    if (c && c.items) c.items.forEach(function (i) { inCos[i.product_id] = true; });
    lista = lista.filter(function (p) { return !inCos[p.id]; });
    /* Tot ce am fi oferit e deja în coș. Punem marcajul oricum, ca să nu
       reintrăm aici la fiecare mutație DOM. */
    if (!lista.length) { f.dataset[MARCAJ] = '1'; return; }

    f.dataset[MARCAJ] = '1';

    /* Bara de transport e și butonul care deschide caruselul.

       De ce închis implicit: pe telefon caruselul băga un ecran întreg de
       poze între câmpul de adresă și butonul de comandă. Cine voia doar să
       comande trebuia să deruleze pe lângă el, iar cine se uita la poze
       ieșea din comandă — s-a văzut o dată în Clarity, un om a atins un
       produs, a fost dus pe pagina lui și comanda a rămas draft (de aceea
       cardurile nu mai sunt linkuri).

       Acum drumul până la buton e scurt, iar produsele rămân la un tap
       distanță pentru cine chiar vrea transport gratuit. */
    var bara = document.createElement('div');
    bara.setAttribute('data-ln-prag', '');
    bara.className = 'ln-prag ln-prag--buton';
    bara.setAttribute('role', 'button');
    bara.setAttribute('tabindex', '0');
    bara.setAttribute('aria-expanded', 'false');
    bara.innerHTML = '<span class="ln-prag__continut"></span>' +
      '<span class="ln-prag__sageata" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" ' +
      'stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></span>';

    var sectiune = document.createElement('section');
    sectiune.setAttribute('data-ln-carusel', '');
    sectiune.className = 'ln-cf';
    /* șina stă într-un înveliș, ca degradeul alb din dreapta să rămână pe
       loc când se derulează */
    sectiune.innerHTML = '<span class="ln-cf__titlu">Cele mai vândute</span>' +
      '<div class="ln-cf__sina"><div class="rel__rail" role="list"></div></div>';
    var sina = sectiune.querySelector('.rel__rail');
    var invelis = sectiune.querySelector('.ln-cf__sina');
    sectiune.hidden = true;

    /* Degradeul are sens doar cât mai e ceva de derulat spre dreapta.
       Când ajungi la ultimul produs, se stinge. */
    function actualizeazaDegradeul() {
      var laCapat = sina.scrollLeft + sina.clientWidth >= sina.scrollWidth - 2;
      invelis.classList.toggle('ln-cf__sina--capat', laCapat);
    }
    sina.addEventListener('scroll', actualizeazaDegradeul, { passive: true });

    function comuta() {
      var deschis = bara.getAttribute('aria-expanded') === 'true';
      bara.setAttribute('aria-expanded', deschis ? 'false' : 'true');
      sectiune.hidden = deschis;
      /* cât e ascuns, lățimile sunt zero — recalculăm la deschidere */
      if (!sectiune.hidden) actualizeazaDegradeul();
    }
    bara.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      comuta();
    });
    bara.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        comuta();
      }
    });

    /* Patru produse, alese la întâmplare la fiecare deschidere de formular.
       Fără butonul „Vezi mai multe": cu cât sunt mai puține de răsfoit, cu
       atât e mai puțin de răsfoit în loc de comandat. */
    for (var a = lista.length - 1; a > 0; a--) {
      var b = Math.floor(Math.random() * (a + 1));
      var tmp = lista[a]; lista[a] = lista[b]; lista[b] = tmp;
    }
    lista = lista.slice(0, PRODUSE_IN_CARUSEL);

    var carduri = lista.map(card);
    carduri.forEach(function (x) { sina.appendChild(x); });
    actualizeazaDegradeul();

    /* În insignă, `la-nani-insigne.js` scrie „4,9 · 44 recenzii". În formular
       n-avem loc pentru tot, dar nota încape — deci tăiem ce vine după punct
       și rămâne doar „4,9", lângă stele.

       O facem DUPĂ ce scrie el, nu în locul lui: insigna e cerută de la
       Judge.me abia când cardul devine vizibil, deci textul apare mai
       târziu. De asta urmărim secțiunea. Nu se poate bucla: după tăiere nu
       mai există punctul separator, deci a doua trecere nu mai schimbă
       nimic. */
    function scurteazaNotele() {
      sectiune.querySelectorAll('.jdgm-prev-badge__text').forEach(function (t) {
        var i = t.textContent.indexOf('·');
        if (i > 0) t.textContent = t.textContent.slice(0, i).trim();
      });
    }
    if ('MutationObserver' in window) {
      new MutationObserver(scurteazaNotele)
        .observe(sectiune, { childList: true, subtree: true, characterData: true });
    }
    scurteazaNotele();

    /* Rândul de compatibilitate, sub carusel. Dimensiunile sunt luate din
       descrierea produsului: „se potrivește paturilor de 180x200 cm,
       160x200 cm, 140x200 cm". */
    var potrivire = document.createElement('div');
    potrivire.className = 'ln-cf__potrivire';
    potrivire.innerHTML = '<span aria-hidden="true">📏</span>' +
      '<span>Perfect pentru paturi de <b>180×200</b>, <b>160×200</b> și <b>140×200 cm</b></span>';
    sectiune.appendChild(potrivire);

    /* Le punem INAINTE de lista de produse, ca sumarul comenzii sa
       ramana lipit de produsele lui: bara, carusel, produse, subtotal.

       RISC CUNOSCUT, NEDOVEDIT — și de asta nu se atinge.

       Nodurile astea intră într-o listă de copii pe care o gestionează Vue:
       părintele e FORM.es-form, componenta lor OrderForm (Vue 2). Măsurat:
       arborele lor virtual are 15 copii, DOM-ul are 17 — cei doi în plus
       sunt ai noștri.

       Un audit independent a încercat în mai multe feluri să provoace o
       eroare de randare și NU a reușit: formularul s-a randat corect și pe
       desktop, și la 375 px, după re-randări, adăugări în coș și scris în
       câmpuri. Deci riscul e structural, nu dovedit. O schimbare aici e mai
       riscantă decât problema.

       ATENTIE, si e important: daca ancora lipseste, NU injectam nimic — nu
       punem noduri direct in .es-modal-content, adica in radacina
       aplicatiei lor. Iesim si incercam din nou la urmatoarea schimbare de
       DOM; observatorul de mai jos ne recheama oricum. */
    var ancora = f.querySelector('.es-cart_content-group') || f.querySelector('.es-order_summary-group');
    if (!ancora || !ancora.parentNode) { delete f.dataset[MARCAJ]; return; }
    ancora.parentNode.insertBefore(bara, ancora);
    ancora.parentNode.insertBefore(sectiune, ancora);

    /* Bara pornește de la coșul pe care tocmai l-am citit — fără încă o
       cerere. Mai departe o ține la zi observatorul de mai jos. */
    if (c) actualizeazaBara(c.total_price);
    urmaresteCosul(f);
  }

  /* ---------- bara de pe pagina de produs ----------
     Aici cosul e de obicei gol, deci „mai adauga un set" n-are sens:
     omul n-a adaugat inca nimic. Ii spunem cate seturi sa comande ca sa
     prinda pragul. Daca are deja produse in cos, trecem pe „mai adauga". */
  function baraDinPagina(proaspat) {
    var el = document.querySelector('.rel__bar');
    if (!el) return;

    var celMaiIeftin = 0;
    citesteProduse().forEach(function (p) {
      var n = Number(p.pret_num);
      if (isFinite(n) && n > 0 && (!celMaiIeftin || n < celMaiIeftin)) celMaiIeftin = n;
    });
    if (!celMaiIeftin) return;

    cos(proaspat).then(function (c) {
      var subtotal = c ? c.total_price : 0;
      var bucati = c ? c.item_count : 0;
      var lipsa = PRAG * 100 - subtotal;

      if (lipsa <= 0) {
        el.innerHTML = '<span aria-hidden="true">🚚</span><span>Transport gratuit</span>';
        return;
      }
      var cate = Math.ceil(lipsa / (celMaiIeftin * 100));
      var text = bucati > 0
        ? 'Vrei transport gratuit? Mai adaugă ' + (cate === 1 ? 'un set' : cate + ' seturi')
        : 'Vrei transport gratuit? Comandă ' + (cate === 1 ? 'un set' : cate + ' seturi');
      el.innerHTML = '<span aria-hidden="true">🚚</span><span>' + text + '</span>';
    });
  }

  /* ---------- pornire ---------- */

  function incearca() {
    if (!CARUSEL_PORNIT) return;
    if (dezactivat) return;
    var f = formular();
    if (!f || f.dataset[MARCAJ]) return;
    /* Fără lista de produse randată de server n-avem ce construi. Se
       întâmplă pe orice pagină care nu e de produs — acolo `construieste`
       ieșea fără să pună marcajul, deci fiecare mutație DOM reintra aici și
       cerea coșul din nou. Ne oprim o dată pentru totdeauna. */
    if (!citesteProduse().length) { dezactivat = true; return; }
    if (!componentaApp()) return;
    /* Injectam abia cand formularul e randat intreg. Butonul de trimitere e
       ultimul care apare, deci prezenta lui inseamna ca Vue a terminat. */
    if (!f.querySelector('.es-cta-group')) { armeazaPaznicul(); return; }
    cos().then(function (c) {
      var f2 = formular();
      if (!f2) return;
      try {
        construieste(f2, c);
      } catch (e) {
        /* Orice ne-a iesit prost, formularul lor conteaza mai mult decat
           caruselul nostru. Scoatem ce am pus si nu mai incercam. */
        dezactivat = true;
        scoateInjectiile();
      }
    });
  }

  function scoateInjectiile() {
    ['[data-ln-prag]', '[data-ln-carusel]'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('.es-modal-content') && el.parentNode) el.parentNode.removeChild(el);
      });
    });
    var f = formular();
    if (f) delete f.dataset[MARCAJ];
  }

  /* ---------- paznicul formularului ----------

     Raportat din inregistrarile Clarity: la unii oameni, dupa apasarea pe
     „Comanda acum", ecranul se intuneca dar formularul nu apare. Acolo se
     opreste comanda.

     Nu am putut reproduce cazul, deci nu pot spune sigur ca noi il cauzam.
     Dar daca il cauzam, asta il repara: dupa 3 secunde de la deschidere,
     daca formularul tot nu are butonul de trimitere, scoatem tot ce am
     injectat si ne oprim definitiv pentru vizita asta.

     Mai bine formularul lor simplu, fara caruselul nostru, decat un ecran
     gol si o comanda pierduta. */
  var paznicArmat = false;
  function armeazaPaznicul() {
    if (paznicArmat) return;
    paznicArmat = true;
    setTimeout(function () {
      var f = formular();
      if (!f) { paznicArmat = false; return; }
      if (f.querySelector('.es-cta-group')) { paznicArmat = false; return; }
      dezactivat = true;
      scoateInjectiile();
    }, 3000);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ln-adauga]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    adauga(b);
  }, true);

  var inCoada = 0;
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (inCoada) return;
      inCoada = setTimeout(function () { inCoada = 0; incearca(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { incearca(); baraDinPagina(); });
  } else {
    incearca();
    baraDinPagina();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-ln-rel-add], [data-ln-add]')) {
      /* coșul chiar s-a schimbat: citire proaspătă, nu din memorie */
      setTimeout(function () { baraDinPagina(true); }, 1200);
    }
  }, true);
})();
